module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Homepage","manuals_title":"User Manuals","questions_title":"Frequently Asked Questions"},"pt-BR":{"title":"Página Inicial","manuals_title":"Manuais de Usuário","questions_title":"Dúvidas Frequentes / FAQ"}}')
  delete Component.options._Ctor
}
